var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v(" Todos os direitos Reservados © "+_vm._s(_vm.year)+". Desenvolvido por "),_c('a',{attrs:{"href":"http://www.codeduck.com.br","target":"_blank"}},[_vm._v("codeduck")])])])}
var staticRenderFns = []

export { render, staticRenderFns }